import { useEffect, useState } from 'react';
import { ViewModalHeader } from './ViewModalHeader';
import axios from 'axios';
import { useAppSelector } from '../../../../../../redux/hooks';
import { useAuth } from '../../../../auth';
import Swal from 'sweetalert2';
import { getUserId, getUserIdglobal, getroles, getrolesglobal } from '../request/request';

const API_URL = process.env.REACT_APP_API_URL;

type Rol = {
  name: string;
  id: number;
  description?: string;
};

type User = {
  firstName: string;
  lastName: string;
  email: string;
  NumberPhone: string;
  position: string;
  Roles: Rol[];
  Tenant: string;
  password?: string;
};

const ViewModalUpdate = (props: any) => {
  const { currentUser } = useAuth();
  const tenant = useAppSelector((state) => state.TenantSlice.id);

  const [userData, setUserData] = useState<User>({
    firstName: '',
    lastName: '',
    email: '',
    NumberPhone: '',
    position: '',
    Roles: [],
    Tenant: '',
  });
  const [Rol, setRol] = useState<Rol[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props.id) {
          if (currentUser?.ListPermiso?.includes('User.Update')) {
            const userResponse =
              tenant === 0 ? await getUserId(props.id) : await getUserIdglobal(props.id, tenant);
            setUserData(userResponse.data);
          }
        }
        if (
          currentUser?.ListPermiso?.includes('User.Create') ||
          currentUser?.ListPermiso?.includes('User.Update')
        ) {
          const rolesResponse =
            tenant === 0 ? await getroles() : await getrolesglobal(tenant);
          setRol(rolesResponse.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [props.id]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (props.id) {
        // Update user
        const url =
          tenant === 0
            ? `${API_URL}/v1/auth0/users/update/${props.id}`
            : `${API_URL}/v1/auth0/users/update/${props.id}?tenantId=${tenant}`;
        await axios.put(url, userData);
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'The user has been updated',
          showConfirmButton: false,
          timer: 1500,
        });
        props.setID(undefined);
        props.fetchUsers(); // Llamamos a fetchUsers para actualizar la lista
      } else {
        // Create user without password
        const newUserData = { ...userData };
        const url =
          tenant === 0
            ? `${API_URL}/v1/auth0/users/create/`
            : `${API_URL}/v1/auth0/users/create/?tenantId=${tenant}`;
        await axios.post(url, newUserData);
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'The user has been created',
          showConfirmButton: false,
          timer: 1500,
        });
        props.setID(undefined);
        props.fetchUsers(); // Llamamos a fetchUsers para actualizar la lista
      }
    } catch (error: any) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message.includes('Payload validation error')
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'An error occurred',
          text: 'Please check the entered data.',
          showConfirmButton: true,
        });
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'An error occurred',
          text: error.response?.data?.message || 'Unknown error',
          showConfirmButton: true,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const isEdit = props.id !== null;

  return (
    <>
      {props.id !== undefined && (
        <div>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            <div className='modal-dialog modal-dialog-centered mw-650px'>
              <div className='modal-content'>
                <ViewModalHeader setID={props.setID} />
                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <form className='form w-100' onSubmit={handleSubmit}>
                    <div className='text-center mb-5'>
                      <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>
                        {isEdit ? 'Edit User' : 'Create User'}
                      </h1>
                    </div>
                    <div className='row'>
                      <div className='col'>
                        <label className='form-label fw-bolder text-marino fs-6 mb-0 f-parrafo'>
                          First Name
                        </label>
                        <input
                          type='text'
                          name='firstName'
                          value={userData.firstName}
                          className='form-control form-control-solid border-gray-300 f-parrafo'
                          onChange={(e) =>
                            setUserData({ ...userData, firstName: e.target.value })
                          }
                        />
                      </div>
                      <div className='col'>
                        <label className='form-label fw-bolder text-marino fs-6 mb-0 f-parrafo'>
                          Last Name
                        </label>
                        <input
                          type='text'
                          name='lastName'
                          value={userData.lastName}
                          className='form-control form-control-solid border-gray-300 f-parrafo'
                          onChange={(e) =>
                            setUserData({ ...userData, lastName: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div>
                      <label className='form-label fw-bolder text-marino fs-6 mb-0 f-parrafo'>
                        Email
                      </label>
                      <input
                        type='text'
                        name='email'
                        value={userData.email}
                        className='form-control form-control-solid border-gray-300 f-parrafo'
                        onChange={(e) =>
                          setUserData({ ...userData, email: e.target.value })
                        }
                        disabled={isEdit}
                      />
                    </div>
                    <div className='row'>
                      <div className='col'>
                        <label className='form-label fw-bolder text-marino fs-6 mb-0 f-parrafo'>
                          Phone Number
                        </label>
                        <input
                          type='text'
                          name='NumberPhone'
                          value={userData.NumberPhone}
                          className='form-control form-control-solid border-gray-300 f-parrafo'
                          onChange={(e) =>
                            setUserData({ ...userData, NumberPhone: e.target.value })
                          }
                        />
                      </div>
                      <div className='col'>
                        <label className='form-label fw-bolder text-marino fs-6 mb-0 f-parrafo'>
                          Job Title
                        </label>
                        <input
                          type='text'
                          name='position'
                          value={userData.position}
                          className='form-control form-control-solid border-gray-300 f-parrafo'
                          onChange={(e) =>
                            setUserData({ ...userData, position: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <br />
                    <p className='form-label fw-bolder text-marino text-center fs-3 mb-0 f-parrafo'>
                      Roles
                    </p>
                    <br />
                    {Rol.map((n: any) => (
                      <div key={n.id}>
                        <div className='form-check form-check-custom form-check-solid'>
                          <input
                            className='form-check-input me-3 border border-azul'
                            name='role'
                            type='radio'
                            value={n.id}
                            checked={userData.Roles[0]?.id === n.id}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                Roles: [{ id: Number(e.target.value), name: '' }],
                              })
                            }
                          />
                          <label className='form-check-label'>
                            <div className='fw-bolder text-gray-800 f-parrafo'>{n.name}</div>
                            <div className='text-gray-600 f-parrafo'>{n.description}</div>
                          </label>
                        </div>
                        <div className='separator separator-dashed my-5'></div>
                      </div>
                    ))}
                    <div className='d-grid mb-10 justify-content-center'>
                      <div className='row'>
                        <div className='col'>
                          <button
                            type='submit'
                            id='kt_sign_in_submit'
                            className='btn btn-primary'
                            disabled={loading}
                          >
                            {!loading && <span className='indicator-label'>Save</span>}
                            {loading && (
                              <span className='indicator-progress' style={{ display: 'block' }}>
                                Please wait...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            )}
                          </button>
                        </div>
                        <div className='col'>
                          <button
                            type='button'
                            className='btn border border-pink text-pink f-parrafo'
                            style={{ width: '200px' }}
                            onClick={() => props.setID(undefined)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show'></div>
        </div>
      )}
    </>
  );
};

export { ViewModalUpdate };
